import { Routes } from '@angular/router';
import { authGuard } from './cores/guards/auth.guard';
import { loginGuard } from './cores/guards/login.guard';
import { activationGuard } from './cores/guards/activation.guard';
import { PERMISSIONS, permissionGuard } from './cores/permissions';

export const routes: Routes = [
  {
    path: '',
    redirectTo: !window?.electron?.isElectron ? '/login' : '/env-config',
    pathMatch: 'full',
  },
  {
    path: 'env-config',
    loadComponent: () => import('./modules/env-config/env-config.component').then(m => m.EnvConfigComponent),
  },
  {
    path: 'activation',
    loadComponent: () => import('./modules/activation/activation.component').then(m => m.ActivationComponent),
    canActivate: [activationGuard],
  },
  {
    path: 'verify-user',
    loadComponent: () => import('./modules/verify-user/verify-user.component').then(m => m.VerifyUserComponent),
  },
  {
    path: 'login',
    loadComponent: () => import('./modules/login/login.component').then(m => m.LoginComponent),
    canActivate: [loginGuard],
  },
  {
    path: 'unauthorized',
    loadComponent: () => import('./shared/components/unauthorized/unauthorized.component').then(m => m.UnauthorizedComponent),
  },
  {
    path: 'point-of-sale',
    loadComponent: () => import('./modules/point-of-sale/point-of-sale.component').then(m => m.PointOfSaleComponent),
    canActivate: [authGuard, permissionGuard],
    data: {
        permissions: [PERMISSIONS.POINT_OF_SALE.VIEW],
    }
  },
  {
    path: 'cash-management',
    loadComponent: () => import('./modules/cash-management/cash-management.component').then(m => m.CashManagementComponent),
    canActivate: [authGuard, permissionGuard],
    data: {
        permissions: [PERMISSIONS.CASH_MANAGEMENT.VIEW],
    }
  },
  {
    path: 'staff-management',
    loadComponent: () => import('./modules/staff-management/staff-management.component').then(m => m.StaffManagementComponent),
    canActivate: [authGuard, permissionGuard],
    data: {
        permissions: [PERMISSIONS.STAFF_MANAGEMENT.VIEW],
    }
  },
  {
    path: 'customer-management',
    loadComponent: () => import('./modules/customer-management/customer-management.component').then(m => m.CustomerManagementComponent),
    canActivate: [authGuard, permissionGuard],
    data: {
        permissions: [PERMISSIONS.CUSTOMER_MANAGEMENT.VIEW],
    }
  },
  {
    path: 'discount-management',
    loadComponent: () => import('./modules/discount-management/discount-management.component').then(m => m.DiscountManagementComponent),
    canActivate: [authGuard, permissionGuard],
    data: {
        permissions: [PERMISSIONS.DISCOUNT_MANAGEMENT.VIEW],
    }
  },
  {
    path: 'payment-methods',
    loadComponent: () => import('./modules/payment-methods/payment-methods.component').then(m => m.PaymentMethodsComponent),
    canActivate: [authGuard, permissionGuard],
    data: {
        permissions: [PERMISSIONS.PAYMENT_METHODS.VIEW],
    }
  },
  {
    path: 'product-management',
    loadComponent: () => import('./modules/product-management/product-management.component').then(m => m.ProductManagementComponent),
    canActivate: [authGuard, permissionGuard],
    data: {
        permissions: [PERMISSIONS.PRODUCT_MANAGEMENT.VIEW],
    }
  },
  {
    path: 'order-management',
    loadComponent: () => import('./modules/order-management/order-management.component').then(m => m.OrderManagementComponent),
    canActivate: [authGuard, permissionGuard],
    data: {
        permissions: [PERMISSIONS.ORDER_MANAGEMENT.VIEW],
    }
  },
  {
    path: 'system-logs',
    loadComponent: () => import('./modules/system-logs/log-viewer.component').then(m => m.LogViewerComponent),
    canActivate: [authGuard, permissionGuard],
    data: {
        permissions: [PERMISSIONS.SYSTEM_LOGS.VIEW],
    }
  },
  {
    path: 'settings',
    loadComponent: () => import('./modules/pos-settings/pos-settings.component').then(m => m.PosSettingsComponent),
    canActivate: [authGuard, permissionGuard],
    data: {
        permissions: [PERMISSIONS.SETTINGS.VIEW],
    }
  },
];
